interface ParsedAvailabilityMessage {
  beforeStore: string;
  storeName: string;
  afterStore: string;
}

export function parseAvailabilityMessage(
  message: string,
  locale = 'en'
): ParsedAvailabilityMessage | null {
  if (!message) return null;

  // English patterns
  const englishPatterns = [
    // "Pick up at the [STORE] store tomorrow when you order before 3PM"
    /^(.+?\s+at\s+the)\s+(.+?)\s+store\s+(.+?)\s+when\s+you\s+order\s+before\s+(.+)$/i,
    // "Ship to the [STORE] store for pickup between [DATES]" or legacy "Pick up at the … store between …"
    /^(.+?\s+(?:at|to)\s+the)\s+(.+?)\s+store\s+(.+)$/i,
  ];

  // French patterns
  const frenchPatterns = [
    // "À ramasser demain au magasin [STORE] si vous passez votre commande avant [TIME]"
    /^(.+?\s+demain\s+au\s+magasin)\s+(.+?)\s+si\s+vous\s+passez\s+votre\s+commande\s+avant\s+(.+)$/i,
    // "Livraison au magasin [STORE] pour un retrait entre le [DATES]" (cart.pickup.in.store.date.new)
    /^(.+?\s+au\s+magasin)\s+(.+?)\s+pour\s+un\s+retrait\s+entre\s+(.+)$/i,
    // Legacy: "À ramasser au magasin de [STORE] entre le [DATES]"
    /^(.+?\s+au\s+magasin\s+de)\s+(.+?)\s+entre\s+(.+)$/i,
  ];

  const patterns = locale === 'fr' ? frenchPatterns : englishPatterns;
  for (const pattern of patterns) {
    const match = message.match(pattern);

    if (match) {
      // Handle different pattern structures
      if (match.length === 5) {
        // English pattern with timing: "Pick up at the [STORE] store tomorrow when you order before 3PM"
        return {
          beforeStore: match?.[1]?.trim(),
          storeName: match?.[2]?.trim(),
          afterStore: `store ${match?.[3]?.trim()} when you order before ${match?.[4]?.trim()}`,
        };
      } else if (match.length === 4) {
        // Check if this is a French pattern or English pattern
        if (locale === 'fr') {
          if (match[1].includes('demain au magasin')) {
            // French "demain" pattern with timing: "À ramasser demain au magasin [STORE] si vous passez votre commande avant [TIME]"
            return {
              beforeStore: match?.[1]?.trim(),
              storeName: match?.[2]?.trim(),
              afterStore: `si vous passez votre commande avant ${match?.[3]?.trim()}`,
            };
          }
          if (match[1].includes('au magasin de')) {
            // Legacy: "À ramasser au magasin de [STORE] entre le [DATES]"
            return {
              beforeStore: match?.[1]?.trim(),
              storeName: match?.[2]?.trim(),
              afterStore: `entre ${match?.[3]?.trim()}`,
            };
          }
          // "Livraison au magasin [STORE] pour un retrait entre le [DATES]"
          return {
            beforeStore: match?.[1]?.trim(),
            storeName: match?.[2]?.trim(),
            afterStore: `pour un retrait entre ${match?.[3]?.trim()}`,
          };
        } else {
          // "Ship to the … store for pickup between …" or legacy "Pick up at the … store between …"
          return {
            beforeStore: match?.[1]?.trim(),
            storeName: match?.[2]?.trim(),
            afterStore: `store ${match?.[3]?.trim()}`,
          };
        }
      }
    }
  }

  // If no pattern matches, return the original message as beforeStore
  return {
    beforeStore: message,
    storeName: '',
    afterStore: '',
  };
}
